import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from './../environments/environment';
import { ActiveGuard } from './core/auth/active.guard';
import { AuthGuard } from './core/auth/auth.guard';
import { DraftGuard } from './core/auth/draft.guard';
import { PaidGuard } from './core/auth/paid.guard';
import { AboutComponent } from './features/about/about.component';
import { AdminDashboardComponent } from './features/admin/components/admin-dashboard/admin-dashboard.component';
import { AppContentCreateComponent } from './features/app-content/app-content-create/app-content-create.component';
import { AppContentUpdateComponent } from './features/app-content/app-content-update/app-content-update.component';
import { CreateAppFormComponent } from './features/app-creation/create-app-form/create-app-form.component';
import { AppPublishingShellComponent } from './features/app-publishing/app-publishing-shell/app-publishing-shell.component';
import { AppSettingsCreationComponent } from './features/app-settings/app-settings-creation/app-settings-creation.component';
import { AppSettingsUpdateComponent } from './features/app-settings/app-settings-update/app-settings-update.component';
import { LoginComponent } from './features/login/login.component';
import { MonetizationComponent } from './features/monetization/monetization.component';
import { NotificationShellComponent } from './features/notifications/components/notification-shell/notification-shell.component';
import { PlanComponent } from './features/plan/plan.component';
import { StatisticsShellComponent } from './features/statistics/components/statistics-shell/statistics-shell.component';

const loginRoute = environment.auth.isLocalLoginEnabled
  ? [
      {
        path: 'login',
        component: LoginComponent,
      },
    ]
  : [];

const routes: Routes = [
  ...loginRoute,
  {
    path: 'apps',
    canActivate: [AuthGuard],
    component: StatisticsShellComponent,
    data: {
      fetchUserApps: true,
    },
  },
  {
    path: 'apps/:appId',
    canActivate: [AuthGuard],
    component: StatisticsShellComponent,
    data: {
      fetchUserApps: true,
    },
  },
  {
    path: 'notifications',
    canActivate: [AuthGuard],
    component: NotificationShellComponent,
    data: {
      fetchUserApps: true,
    },
  },
  {
    path: 'notifications/:appId',
    canActivate: [AuthGuard],
    component: NotificationShellComponent,
    data: {
      fetchUserApps: true,
    },
  },
  {
    path: 'admin',
    canActivate: [AuthGuard],
    component: AdminDashboardComponent,
    data: {
      fetchUserApps: true,
    },
  },
  {
    path: 'create',
    canActivate: [AuthGuard],
    component: CreateAppFormComponent,
    data: {
      isCreationProcess: true,
    },
  },
  {
    path: 'create/:appId',
    canActivate: [AuthGuard, DraftGuard],
    component: CreateAppFormComponent,
    data: {
      isCreationProcess: true,
    },
  },
  {
    path: 'configure/:appId',
    canActivate: [AuthGuard, DraftGuard],
    component: AppContentCreateComponent,
    data: {
      isCreationProcess: true,
    },
  },
  {
    path: 'simulator/:appId',
    canActivate: [AuthGuard, ActiveGuard],
    component: AppContentUpdateComponent,
    data: {
      fetchUserApps: true,
    },
  },
  {
    path: 'plan/:appId',
    canActivate: [AuthGuard, PaidGuard],
    component: PlanComponent,
    data: {
      isCreationProcess: true,
    },
  },
  {
    path: 'assets/:appId',
    canActivate: [AuthGuard, DraftGuard],
    component: AppSettingsCreationComponent,
    data: {
      isCreationProcess: true,
    },
  },
  {
    path: 'monetization/:appId',
    canActivate: [AuthGuard, DraftGuard],
    component: MonetizationComponent,
    data: {
      isCreationProcess: true,
    },
  },
  {
    path: 'update/:appId',
    canActivate: [AuthGuard, ActiveGuard],
    component: AppSettingsUpdateComponent,
    data: {
      fetchUserApps: true,
    },
  },
  {
    path: 'publishing/:appId',
    canActivate: [AuthGuard],
    component: AppPublishingShellComponent,
    data: {
      fetchUserApps: true,
    },
  },
  {
    path: 'about',
    component: AboutComponent,
  },
  { path: '', redirectTo: '/apps', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
